export default function Card({ title, value, change, isPositive }){
  
  // Format the change value to handle decimals and edge cases
  const formatChange = (changeValue) => {
    if (typeof changeValue !== "number" || isNaN(changeValue)) {
      return "0";
    }
    // Round to 1 decimal place and avoid -0
    const roundedChange = Math.round(changeValue * 10) / 10;
    return roundedChange === 0 ? "0" : roundedChange.toString();
  };

  const displayValue = value !== "N/A" ? value : "0";
  const displayChange = formatChange(change);
  const changeColor = isPositive ? "text-[#1A9882]" : "text-[#D10C00]";
  const prefix = displayChange > 0 ? "+" : "";

  return (
    <div className="min-h-[65px] md:h-[112px] lg:h-auto min-w-[207px] flex-shrink-0 md:min-w-[250px] lg:min-w-full flex flex-col gap-2 bg-white border border-[#EBEBEB] rounded-lg p-4 shadow-sm">
      <h3 className="text-[14px] text-[#777980]">{title}</h3>
      <div className="flex items-end justify-between gap-2">
        <span className="text-[16px] xl:text-[32px] font-[600]">
          {displayValue}
        </span>
        <div
          className={`flex items-center gap-x-1 font-medium text-[12px] lg:text-[16px] ${changeColor}`}
        >
          {prefix}
          {displayChange}%
          <img
            src={isPositive ? "/enqincrement.svg" : "/enqdecrement.svg"}
            alt={isPositive ? "Increase" : "Decrease"}
            className="w-4 h-4"
          />
        </div>
      </div>
    </div>
  );
};